(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerContent = this.querySelector('.header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isOverlap = this.classList.contains('header-layout--overlap');

      this.headerColorScheme = this.dataset.headerColorScheme;
      this.containerColorScheme = this.dataset.containerColorScheme;
      this.overlayColorScheme = this.dataset.overlayColorScheme;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);

      this.setHeaderHeight();
      this.setColorState(this.currentScrollTop > 0);

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.mediaQuery.addEventListener('change', this.setHeaderHeightHandler);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.setHeaderHeightHandler);
        this.resizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setElementColorScheme(element, targetScheme) {
      if (!element || !targetScheme) return;

      [this.headerColorScheme, this.containerColorScheme, this.overlayColorScheme]
        .filter(Boolean)
        .forEach((scheme) => element.classList.remove(`color-${scheme}`));

      element.classList.add(`color-${targetScheme}`);
    }

    setColorState(isSolid) {
      if (!this.isOverlap) return;

      this.setElementColorScheme(
        this,
        isSolid ? this.headerColorScheme : this.overlayColorScheme
      );

      this.setElementColorScheme(
        this.headerContent,
        isSolid ? this.containerColorScheme : this.overlayColorScheme
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.mediaQuery) {
        this.mediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.currentScrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.setColorState(true);
        }

        currentObserver.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setColorState(true);

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setColorState(true);

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.setColorState(false);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
